import { StoreList } from './StoreList';
import StoreIcon from '@material-ui/icons/Store';

export default {
  icon: StoreIcon,
  list: StoreList,
};
